/* 
 * 21.02.2018
 * NewCatController ile birlikte CategoryAndFilters.js yerine kullanılır
 * Infinity Scroll yerine Paging yapısına uygundur
 * $(document).ready 'nin üstünde bulunan fonksiyonlar açılışta çağrılır
 * $(document).ready 'nin altında bulunan fonksiyonlar event'lara bağlıdır, $(document).ready 'deki click olaylarıyla tetiklenir
 */

var date = new Date();
date.setTime(date.getTime() + (5 * 60 * 1000));

function GetLeftCatalogList() {

    $curCatalog = $("#MainMenu a[data-rel='" + $("#PID").val() + "']");

    if ($curCatalog.length > 0) {

        $curUL = $curCatalog.closest(".itemsWrapper").closest("li").first().clone();

        if ($curUL.length < 1) {
            $curUL = $curCatalog.closest("li").first().clone();
        }

        $curUL.find(".itemsWrapper").css("max-height", "180px").css("overflow", "auto");
        $curUL.find(".itemsWrapper").addClass("FilterBoxes");

        $(".SubCatNavs").html("");
        $(".SubCatNavs").append($curUL);

        $selectedCats = $("#MainMenu a[data-rel='" + $("#PID").val() + "']");
        $selectedCats2 = $("#SubCatNavs a[data-rel='" + $("#PID").val() + "']");

        $selectedCats2.css("font-weight", "bold");
        $selectedCats2.css("color", "#797979");

        if ($selectedCats2.parent().parent().parent().hasClass("ListWrapper")) {
            $selectedCats2.parent().addClass("opened");
        } else {
            $selectedCats2.parent().closest("div").parent().addClass("opened");
        }
    }
    $(".SubCatNavs>li .itemsWrapper .ListWrapper>ul>").each(function () {

        if ($(this).find("div ul li").length == 0) {
            $(this).addClass("hidePlusIcon");
        }
    });
}

function ToggleLeftBarItems() {
    if ($(window).width() > 767) {
        $(".itemsWrapper > .ListWrapper > ul > li").live("click", function () {
            $(".itemsWrapper  .ListWrapper  ul  li").not(this).removeClass("opened");
            $(this).toggleClass("opened");
        });
    }
}

function ToggleLeftBar() {

    $(".FilterForm .filterLink").live("click", function () {
        if ($(this).hasClass("toggle-minus")) {
            $(this).removeClass("toggle-minus");
            $(this).parent().find(".FilterBoxes").css("display", "none");
        }
        else {
            $(this).addClass("toggle-minus");
            $(this).parent().find(".FilterBoxes").css("display", "block");
        }
    });

    $(".SubCatNavs > li > a").live("click", function (e) {
        $(this).parent().find(".itemsWrapper").slideToggle();
        $(this).parent().toggleClass("toggle-minus");
        e.preventDefault;
        return false;
    });
}

function SetPriceSlider() {
   
    if ($(".CategoryLeftBar").length > 0 && ($("#PgType").val() == "Cat" || $("#PgType").val() == "NewSearch")) {
    
        var slider = document.getElementById('PriceSlider');
        var min = $("#MinPrice").val();
        var max = $("#MaxPrice").val();
        var currencySymbol = $("#CurrencySymbol").val();

        noUiSlider.create(slider, {
            start: [min, max],
            connect: true,
            step: 1,
            range: {
                'min': parseInt(min),
                'max': parseInt(max)
            }
        });

        slider.noUiSlider.on('change', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            $("#SliderValue").val(Math.round(values[0]) + "-" + Math.round(values[1]));

            //if (IsAutoScrollOpen) {
            //    $(".Products").html("");
            //}

            // window.location.hash = compress($("form#FilterForm, form#CatFilterForm").serialize());
        });

        slider.noUiSlider.on('update', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            $(".priceView").html("").html(Math.round(values[0]) + " " + currencySymbol + "<span style='padding: 0px 35px;'></span> " + Math.round(values[1]) + " " + currencySymbol);
        });
    }
}

function LazyLoad() {
    //$(".ProductList .Prd img.PImage").Lazy();

    //if ($(window).width() > 767) {
    //    $(".ProductList .Prd .ProductListColor img").Lazy();
    //}
}

// Cookie Değerine Göre Açılış Grid'ini Ayarlama Fonksiyonu
function SetGridByCookie() {
    var cookieGrid = $.cookie("TTgridCookie");

    if (cookieGrid == "" || cookieGrid == null || cookieGrid == undefined) {
        cookieGrid = "3";
        $.cookie("TTgridCookie", "3", { path: '/' }, { expires: 7 });
    }

    if ($(window).width() > 767) { // Desktop grid ayarlama
        DesktopGridSet(cookieGrid);
    }
    else if ($(window).width() < 767) { // Mobile grid ayarlama        
        MobileGridSet(cookieGrid);
    }
}

function IsSearch() {
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

    if (NativeQueryFilter.indexOf("sr=") != "-1") {
        return true;
    }
    else {
        return false;
    }
}

// Açılışta QueryString'deki Filtreleme Seçeneklerini Kontrol Eder
function QueryStringControlForFilter() {

    var vars = [], hash;
    var selectedSize = "";
    var selectedColor = "";
    var selectedPrice = "";
    var selectedSoldOut = "";
    var selectedSort = "";
    var selectedPropertie = "";
    var selectedCloth = "";
    var selectedPage = "";
    var haveFilter = false;

    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder

    if (NativeQueryFilter.indexOf("=") != "-1") {

        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "s") {
                selectedSize = hash[1]; // Size değerleri alınır
                haveFilter = true;
            }
            else if (hash[0] == "c") {
                selectedColor = hash[1]; // Color değerleri alınır
                haveFilter = true;
            }
            else if (hash[0] == "prc") {
                selectedPrice = hash[1]; // Price değerini alınır
                haveFilter = true;
            }
            else if (hash[0] == "so") {
                selectedSoldOut = hash[1]; // Tükenenleri Gizle seçeneğini alır
                haveFilter = true;
            }
            else if (hash[0] == "o") {
                selectedSort = hash[1]; // Sıralama seçeneği alınır
                haveFilter = true;
            }
            else if (hash[0] == "prp") {
                selectedPropertie = hash[1]; // Sıralama seçeneği alınır
                haveFilter = true;
            }
            else if (hash[0] == "clh") {
                selectedCloth = hash[1]; // Sıralama seçeneği alınır
                haveFilter = true;
            }
            else if (hash[0] == "p" && IsSearch) {
                selectedPage = hash[1]; // Sıralama seçeneği alınır
                haveFilter = true;
            }
        }

        // Seçili Size'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedSize != null && selectedSize != "" && selectedSize != undefined) {
            var selectedSizes = selectedSize.split(',');

            $.each(selectedSizes, function (key, value) {
                $li = $("#Sizes li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Size'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Color'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedColor != null && selectedColor != "" && selectedColor != undefined) {
            var selectedColors = selectedColor.split(',');

            $.each(selectedColors, function (key, value) {
                $li = $("#Colors li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Color'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedPropertie != null && selectedPropertie != "" && selectedPropertie != undefined) {
            var selectedProperties = selectedPropertie.split(',');

            $.each(selectedProperties, function (key, value) {
                $li = $("#Properties li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Kumaşların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedCloth != null && selectedCloth != "" && selectedCloth != undefined) {
            var selectedCloths = selectedCloth.split(',');

            $.each(selectedCloths, function (key, value) {
                $li = $("#Cloth li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Price değer aralığını ayarlar
        if (selectedPrice != null && selectedPrice != "" && selectedPrice != undefined) {

            $("#SliderValue").val(selectedPrice);
            var SelectedPrices = selectedPrice.split('-');

            var slider = document.getElementById('PriceSlider');
            slider.noUiSlider.set([SelectedPrices[0], SelectedPrices[1]]);
        }
        // Seçili Price değer aralığını ayarlar

        // Seçiliyse tükenenleri gizle seçeneğini işaretler
        if (selectedSoldOut != null && selectedSoldOut != "" && selectedSoldOut != undefined && selectedSoldOut == "1") {
            $li = $("#SoldOutOp li.gr");
            $li.find("input").attr("checked", "checked");
            $li.find("input").val("1");
            $li.find("label").addClass("checked2");
        }
        // Seçiliyse tükenenleri gizle seçeneğini işaretler

        // Sıralama varsa dropdown'dan seçeneği işaretler
        if (selectedSort != null && selectedSort != "" && selectedSort != undefined) {

            $li = $("#PrdSort input[value='" + selectedSort + "']").parent("li");

            $li.find("label").addClass("checked");
            $li.find("label").addClass("c_on");

            $(".fLinkSortNo").html($li.find("label .checkText").html()); // Seçili sıralama seçeneğini gösterir
        }
        // Sıralama varsa dropdown'dan seçeneği işaretler

        // Arama sayfasına geri geldiğinde istek yapar.
        if (IsSearch() && haveFilter) {
            getPageByPageNo(selectedPage, true);
            //GetPageByFilter();      
        }
    }

    GetSelectedFilter(); // Gelen filtreleri Seçili Filtreler alanına ekler
}

// Seçimleriniz alanını footer'da gizler
function HideChoices() {

    //$(window).scroll(function (event) {
    //    var ProductHeight = $(".Products").height();
    //    var ContentHeight = $(".contentTopSpace").height();
    //    var HeaderHeight = $("header").height();
    //    var y = $(this).scrollTop();

    //    var calc = ContentHeight + HeaderHeight - ProductHeight;
    //    var scrollPosition = y + calc + 120;

    //    if (scrollPosition >= ProductHeight) {
    //        $(".SelectedFilter").fadeOut(250);

    //    } else {
    //        $(".SelectedFilter").fadeIn(250);
    //    }
    //});

    $(window).scroll(function (event) {
        var y = $(this).scrollTop();
        var height = 0;

        $(".FilterForm .col-md-24").not(".AppylArea").each(function () {
            height += $(this).height();
        });

        height = height - 700;

        if (y >= height) {
            $(".AppylArea").removeClass("AppylAreaFixed");

        } else {
            $(".AppylArea").addClass("AppylAreaFixed");
        }
    });

}

// Detaydan Listeleme Sayfasına Geri Dönmede Scroll Position'ı Ayarlar
function BackButtonLastScroll() {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var browserName = navigator.userAgent;
    if (browserName.indexOf("Chrome")) {
        browserName = "Chrome";
    }

    var pgType = $("#PgType").val();
    var lastScrollTop = $.cookie("lastScroll");
    var CatID = $("#PID").val();
    var lastScrollTopFirst = $.cookie("getLastScrollFirst");

    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

    if (pgType == "Cat" || pgType == "NewSearch") {

        if (CatID != $.cookie("lastCatalogID")) {
            lastScrollTopFirst = 0;
            $.cookie("lastCatalogID", CatID, { path: '/', expires: date });
        }

        if (NativeQueryFilter.indexOf("=") != "-1") { // kataloğun ilk sayfası ise lastScroll'u dikkate almasın
            if (lastScrollTop != null && lastScrollTop != "" && lastScrollTop != undefined && lastScrollTop > 0) {
                setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: lastScrollTop
                    }, 0);
                }, 1000);
            }
        }
        else {

            if (lastScrollTopFirst != null && lastScrollTopFirst != "" && lastScrollTopFirst != undefined && lastScrollTopFirst > 0) {
                setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: lastScrollTopFirst
                    }, 0);
                }, 1000);
            }
        }
        
        $.cookie("getLastScrollFirst", "0", { path: '/', expires: date });
        $.cookie("lastScroll", "0", { path: '/', expires: date });
    }
}

function IsFollowCatagory() {

    if ($(".PrdImgsBox div .QuickLookLikeBtn").length <= 0) {
        return;
    }

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/IsFollowAll",
        dataType: 'json',
        async: true,
        success: function (dt) {
            updateList(dt);
        }
    });

    var updateList = function (dt) {
        $(".PrdImgsBox .QuickLookLikeBtn").addClass("passiveFavorite");
        $(".PrdImgsBox .QuickLookLikeBtn").removeClass("activeFavorite");
        for (var i in dt) {
            var item = dt[i];

            var followlar = $(".PrdImgsBox div .QuickLookLikeBtn").filter(function (index) {
                return $(this).attr("data-productidlike") == item["ProductID"] && $(this).attr("data-coloridlike") == item["ColorID"];
            });



            if (followlar.length > 0) {
                var followItem = $(followlar[0]);
                followItem.removeClass("passiveFavorite");
                followItem.addClass("activeFavorite");

                if (followItem.hasClass("activeFavorite")) {
                    followItem.children("img").attr("src", "/Images/TTE/Icons/favori_aktif.png");
                }
            }
        }
    };




}

function AddToFavoriteNewCt() {

    $(".PrdImgsBox div .QuickLookLikeBtn.passiveFavorite").live("click", function () {

        $That = $(this);
        var ProductID = $(this).attr("data-productidlike");
        var ColorID = $(this).attr("data-coloridlike");

        if (ColorID != undefined && ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
                data: 'colorID=' + ColorID + "&productID=" + ProductID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("activeFavorite");
                        $That.removeClass("passiveFavorite");
                        if ($That.hasClass("activeFavorite")) {
                            $That.children("img").attr("src", "/Images/TTE/Icons/favori_aktif.png");
                        }
                    }
                    else if (dt.Sonuc == false) {
                        alert('Favorilere eklemek için giriş yapınız!');
                    }
                },
                error: function (httpObj, textStatus) {

                    //if (httpObj.status == 401) {
                    //    alert('Favorilere Eklemek için giriş yapınız.');
                    //}
                    //else {
                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    //}
                }
            });
        }
    });
}

function removeFavoriteNewCt() {

    $(".PrdImgsBox div .activeFavorite").live("click", function () {
        $That = $(this);
        var ProductID = $(this).attr("data-productidlike");
        var ColorID = $(this).attr("data-coloridlike");
        var LangID = $("#LangID").val();

        if (ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
                data: 'id=' + ProductID + '&LangID=' + LangID + '&isDetail=true',
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("passiveFavorite");
                        $That.removeClass("activeFavorite");
                        if ($That.hasClass("passiveFavorite")) {
                            $That.children("img").attr("src", "/Images/TTE/Icons/favori_default.png");
                        }
                    }
                },
                error: function (httpObj, textStatus) {
                    if (httpObj.status == 401) {
                        alert('Favorilerden çıkartmak için giriş yapınız.');
                    }
                    else {
                        alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    }
                }
            });
        }
    });
}

//$(".ProductList .Prd img.PImage, .ProductList .Prd .ProductListColor img").Lazy();

$(document).ready(function () {
    LazyLoad();
    AddToFavoriteNewCt();
    removeFavoriteNewCt();
    IsFollowCatagory();

    var PageType = $("#PgType").val();

    if (PageType == "Cat" || PageType == "Combine") {

        // Left/Filter Bar
        GetLeftCatalogList();
        ToggleLeftBarItems();

        window.onpageshow = function (event) {
            if (event.persisted) {
                setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: window.scrollY + 2
                    }, 0);
                }, 1000);
            }
        };

        if ($(window).width() > 767) {
            HideChoices(); // Seçimleriniz alanını footer'da gizler(Sadece Desktop)
        }

    }

    if (PageType == "Cat" || PageType == "Combine" || PageType == "NewSearch") {
        SetGridByCookie(); // Cookie Değerine Göre Grid Ayarlama
        SetPriceSlider();
        ToggleLeftBar();
        ClearAllFilter("false");
        QueryStringControlForFilter(); // QueryString'deki filtreleri kontrol eder

        BrowserBackAndPrevButtonControl(); // Browser iler/geri tuşları tetiklenince çalışır
        BackButtonLastScroll(); // Detaydan Listeleme Sayfasına Geri Dönmede Scroll Position'ı Ayarlar  
    }


    // Renk ve Beden Filteri
    $('#Colors > li, #Sizes > li, #Properties > li, #Cloth > li').click(function (event) {
        FilterItemSelect($(this));
    });

    // Seçili Filtre Alanını Açıp/Kapatır
    $(".SelectedFilter .SelectedFilterHeader").click(function (event) {
        if ($(window).width() > 767) {
            var status = $(".SelectedFilter .SelectedFilterBody").hasClass("closed");
            var sendEvent = "";

            if (status == false) {
                sendEvent = "Down";
            }
            else {
                sendEvent = "Up";
            }

            if (sendEvent != null && sendEvent != "" && sendEvent != undefined) {
                OpenCloseSelectedFilterArea(sendEvent);
            }
        }

    });

    // Seçili Filtreler Alanındaki Filteri Kaldırma
    $(".SelectedFilterCancelIcon").live("click", function () {
        var selectedVal = $(this).attr("data-value");
        var selectedType = $(this).attr("data-type");

        ClearSelectedFilter(selectedVal, selectedType);
    });

    // Tüm Filtreleri Kaldırır
    $(".SelectedFilter .ClearAllFilter").live("click", function () {
        ClearAllFilter("true");
    });

    // Tükenenleri Gizle
    $('#SoldOutOp > li.gr input').click(function (event) {
        SoldOutFilter($(this));
    });

    // Sıralama
    $('#PrdSort > li input').click(function (event) {
        ProductSort($(this));
    });

    // Desktop Grid Seçimi
    $(".mGridIcons-3, .mGridIcons-4").click(function () {
        var gridID = $(this).attr("data-gridvalue");

        if (gridID != null && gridID != undefined && gridID != "") {
            DesktopGridSet(gridID);
        }
    });

    // Mobile Grid Seçimi
    $("#gridAyarla").click(function () {
        if ($(window).width() < 767) {
            var gridID = $(this).attr("data-grid");
            cookieGrid = $.cookie("TTgridCookie");

            if (gridID != null && gridID != undefined && gridID != "") {
                MobileGridSet(gridID);
                $.cookie("TTgridCookie", gridID, { path: '/' });
            }
        }
    });

    // Yeni Açının Çağrılması
    $(".ProductList .carousel-control").live("click", function () {
        GetProductNextOrPrevImage();
    });

    // Paging İsteği
    $(".Pages a, #nextPage a").live("click", function () {
        var pageNo = $(this).attr("data-pgno");

        $.cookie("lastScroll", 0, { path: '/', expires: date });
        $.cookie("getLastScrollFirst", 0, { path: '/', expires: date });

        if (pageNo != null && pageNo != undefined && pageNo != "") {
            getPageByPageNo(pageNo, "false");
        }
    });

    // Ürün'e Tıklandığında Scroll Position Alınır
    $(".ProductList a img:not(.NextPageImg)").live("click", function () {
        var lastScroll = $(window).scrollTop();
        var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

        if (NativeQueryFilter.indexOf("=") != "-1") {
            $.cookie("lastScroll", lastScroll, { path: '/', expires: date });
        }
        else {
            $.cookie("getLastScrollFirst", lastScroll, { path: '/', expires: date });
        }

    });

    // Filtreleme İsteği
    $(".AppylArea .FilterApplyButton").live("click", function () {
        GetPageByFilter();
    });

    // Kategori Açıklama Yazısını Gösterir
    $('.CatShowMore, .CatShowLess').on('click', function (e, index) {
        var Clicked = $(this).attr("class");
        CatDescShowOrHide(Clicked);
    });

    // Mobil İçin Filtre ve Sıralama Alanını Açar
    $(".OpenFilterOrSortArea").click(function () {
        var area = $(this).parent().hasClass("FilterDiv"); // Tıklanan butonun filtre mi sıralama mı olduğuna mı bakılıyor

        if (area == true) {
            MobilSortFilterAreaOpenOrClose(".mobilFilterArea", "Open");
        }
        else {
            MobilSortFilterAreaOpenOrClose(".MobilSortArea", "Open");
        }
    });

    // Mobil İçin Filtre ve Sıralama Alanını Kapatır
    $(".CloseFilterOrSortArea").click(function () {
        var area = $(this).hasClass("CloseFilter"); // Tıklanan butonun filtre mi sıralama mı olduğuna mı bakılıyor

        if (area == true) {
            MobilSortFilterAreaOpenOrClose(".mobilFilterArea", "Close");
        }
        else {
            MobilSortFilterAreaOpenOrClose(".MobilSortArea", "Close");
        }
    });
});

// Kategori Açıklama Yazısını Açıp/Kapatır
function CatDescShowOrHide($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "CatShowMore") {
            $(".CatShowMore").hide();
            $('.CatShowLess').show();
            $('.CatSecondPart').show();
            $('.CatShortPart').hide();
        }
        else {
            $(".CatShowLess").hide();
            $('.CatShowMore').show();
            $('.CatSecondPart').hide();
            $('.CatShortPart').show();
        }
    }
}

// Filteleri seçili yapar
function FilterItemSelect($GroupName) {
    $li = $GroupName;

    if ($li.find("input:checked").length > 0) {

        $li.find("input").removeAttr("checked");
        $li.removeClass("selected");
        $li.find("label").removeClass("c_on");
    }
    else {
        $li.find("input").attr("checked", "checked");
        $li.addClass("selected");
        $li.find("label").addClass("c_on");
    }

    $li.find("input").trigger("change");
}

// Seçili Filtre Alanını Açıp/Kapatan Fonksiyon (Up/Down değeri alır)
function OpenCloseSelectedFilterArea($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "Up") {
            $(".SelectedFilterBody").slideDown("slow");
            $(".SelectedFilter .SelectedFilterBody").removeClass("closed");
        }
        else if ($event == "Down") {
            $(".SelectedFilterBody").slideUp("slow");
            $(".SelectedFilter .SelectedFilterBody").addClass("closed");
        }
    }
}

// Tükenenleri Gizle Seçeneğini Kontrol Eden Fonksiyon
function SoldOutFilter($soldOut) {

    $li = $soldOut.parent();

    if ($li.find("input").val() == "0") {
        $li.find("label").addClass("checked2");
        $li.find("input").val("1");
        GetPageByFilter();
    }
    else {
        $li.find("label").removeClass("checked2");
        $li.find("input").val("0");

        var currentPage = $(".Pages a.selected").attr("data-pgno");
        getPageByPageNo(currentPage, "false");
    }

}

// Sıralama Seçeneğini Kontrol Eden Fonksiyon
function ProductSort($selectedSort) {

    $li = $selectedSort.parent();

    // Tüm seçenekleri kapatır
    $("#PrdSort input").removeAttr("checked");
    $("#PrdSort label").removeClass("checked");
    $("#PrdSort label").removeClass("c_on");

    // Kullanıcının istediği seçeneği seçili yapar
    $li.find("label").addClass("checked");
    $li.find("label").addClass("c_on");

    // Sıralama ekranını kapatır
    $(".fLinkSortNo").removeClass("toggle-minus");
    $("#PrdSort").parent().hide();

    $(".fLinkSortNo").html($li.find("label .checkText").html()); // Seçili sıralama seçeneğini gösterir

    var currentPage = $(".Pages a.selected").attr("data-pgno"); // Kullanıcının bulunduğu sayfa alınır

    if (IsSearch()) {
        currentPage = "1";
    }

    getPageByPageNo(currentPage, "false");

}

// Desktop Grid Seçim Fonksiyonu
function DesktopGridSet($gridSize) {
    var removeClass = "";
    var addClass = "";
    var ActiveIcons = "";
    var PasiveIcons = "";
    var AddToCartAreaWidth = "";
    var gridValue = "";
    var selectedGridClass = "";
    var deSelectedGridClass = "";
    var PageType = $("#PgType").val();

    if ($gridSize == "3") {
        removeClass = "quaternary";
        addClass = "";
        ActiveIcons = "/Images/TTE/Icons/3_siyah.png";
        PasiveIcons = "/Images/TTE/Icons/4_gri.png";
        AddToCartAreaWidth = "94%";
        gridValue = "3";
        selectedGridClass = ".mGridIcons-" + gridValue;
        deSelectedGridClass = ".mGridIcons-4";
    }
    else if ($gridSize == "4") {
        removeClass = "";
        addClass = "quaternary";
        ActiveIcons = "/Images/TTE/Icons/4_siyah.png";
        PasiveIcons = "/Images/TTE/Icons/3_gri.png";
        AddToCartAreaWidth = "92%";
        gridValue = "4";
        selectedGridClass = ".mGridIcons-" + gridValue;
        deSelectedGridClass = ".mGridIcons-3";
    }


    if (PageType != null && PageType != "" && PageType != undefined && PageType != "Combine") {
        //$(".PrdContainer .ProductList .Prd").removeClass(removeClass).addClass(addClass);
        $(".PrdContainer .ProductList").removeClass(removeClass).addClass(addClass);

        $(selectedGridClass).css("background-image", "url(" + ActiveIcons + ")");
        $(deSelectedGridClass).css("background-image", "url(" + PasiveIcons + ")");

        //$(".PrdContainer .Prd .AddToCartArea").css("width", AddToCartAreaWidth);
    }
    else if (PageType != "Combine") {
        $(".PrdContainer .ProductList .Prd").addClass("col-md-12 col-xs-24");
    }

    $.cookie("TTgridCookie", gridValue, { path: '/' });

}

// Mobile Grid Seçim Fonksiyonu
function MobileGridSet($gridSize) {
    if ($gridSize == "3") {
        $(".PrdContainer .ProductList").removeClass("quaternary");
        $(".PrdContainer .ProductList .Prd .carousel .carousel-indicators").css("left", "14%");

        $(".AddToCartArea").css("position", "relative");
        $(".AddToCartArea").css("bottom", "0px");
        $(".AddToCartArea").css("display", "unset");
        $(".AddToCartArea").css("width", "99.5%");
        $(".AddToCartArea .AddToCart").css("display", "none");
        $(".AddToCartArea .ProductListColorContainer").css("display", "none");

        //$(".ProductList .Prd").css("padding", "1px");
        //$(".ProductBadge").css("display", "none");

        $("#gridAyarla").attr("data-grid", "4");
    }
    else {
        $(".PrdContainer .ProductList").addClass("quaternary");
        $(".PrdContainer .ProductList .Prd .carousel .carousel-indicators").css("left", "7%");

        $(".AddToCartArea").css("position", "static");
        $(".AddToCartArea").css("bottom", "0px");
        $(".AddToCartArea").css("display", "inline-table");
        $(".AddToCartArea").css("width", "100%");

        $(".AddToCartArea .AddToCart").css("display", "unset");
        $(".AddToCartArea .AddToCart").css("width", "100%");
        $(".AddToCartArea .ProductListColorContainer").css("display", "table");

        //$(".ProductBadge").css("display", "unset");

        $("#gridAyarla").attr("data-grid", "3");
    }
}

// Yeni Açıyı Çağırma Fonksiyonu
function GetProductNextOrPrevImage() {

    var ImageSrc = $(".ProductList .carousel-inner .next a img").attr("src");
    $nextOrPrevImage = $(".ProductList .carousel-inner .next a img");

    if (ImageSrc == null || ImageSrc == "" || ImageSrc == undefined) {
        ImageSrc = $(".ProductList .carousel-inner .prev a img").attr("src");
        $nextOrPrevImage = $(".ProductList .carousel-inner .prev a img");
    }

    if (ImageSrc.indexOf("lazy_back_new.jpg") != -1) {
        $nextOrPrevImage.attr("src", $nextOrPrevImage.attr("data-img"));
    }
}

// Filtreleme Ve Sayfa Geçişlerinde Loader Gösterip Gizler
function ShowOrHideBackDrop($event) {

    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "show") {
            $(".backdrop").addClass("ShowBackdrop");
            $(".LoadingGif").show();
        }
        else if ($event == "hide") {
            $(".backdrop").removeClass("ShowBackdrop");
            $(".LoadingGif").hide();
        }
    }

}

// Paging İçin Ajax --> IsBack parametresi URL History oluşturmak için alınır
function getPageByPageNo($pageNo, $IsBack) {
    if ($pageNo != null && $pageNo != "" && $pageNo != undefined && $pageNo != "0") {

        if ($IsBack != null && $IsBack != "" && $IsBack != undefined && $IsBack == "false") {
            GenerateUrlHistoy(); // URL History oluşturur
        }

        ShowOrHideBackDrop("show"); // Loader gösterilir

        var newScrollPosition = $(".Products").position();

        if ($IsBack == "false") {
            $('html, body').animate({ // Listenin başına döndürür
                scrollTop: newScrollPosition.top
            }, 0);
        }

        var params = GenerateParams("paging", $pageNo); // Sayfalama için istek parametresi üretir

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/Home/GetProductList",
            data: params,
            cache: false,
            success: function (data) {

                ShowOrHideBackDrop("hide"); // Loader kapatılır

                var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                var newURL = location.pathname + "?" + params;

                if (ios == false) {
                    window.history.replaceState({}, "", newURL); // Sayfa URL'inin değişmesini sağlar
                }
                else {
                    history.pushState({}, "", newURL);
                }

                if ($(".ProductList .NotFound").length <= 0) {
                    $(".Products").html(data);
                    LazyLoad();
                }

                var cookieGrid = $.cookie("TTgridCookie");
                if ($(window).width() < 767) {
                    MobilSortFilterAreaOpenOrClose(".MobilSortArea", "Close");
                    MobileGridSet(cookieGrid);
                }
                else {
                    DesktopGridSet(cookieGrid);
                }
            },
            error: function () {
                ShowOrHideBackDrop("hide"); // Loader kapatılır
            }
        });

    }
}

// Filter İçin Ajax
function GetPageByFilter() {

    ShowOrHideBackDrop("show"); // Loader gösterilir

    var newScrollPosition = $(".Products").position(); // Filtreleme&Sayfalama işleminden sonra scroll'un gideceği position değeri

    $('html, body').animate({ // Listenin başına döndürür
        scrollTop: newScrollPosition.top
    }, 0);

    var params = GenerateParams("filter"); // Filtreleme için istek parametresi üretir

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetProductList",
        data: params,
        cache: false,
        success: function (data) {

            ShowOrHideBackDrop("hide"); // Loader kapatılır
            window.history.replaceState({}, "", location.pathname + "?" + params); // Sayfa URL'inin değişmesini sağlar

            $(".Products").html(data);
            LazyLoad();

            if ($(window).width() < 767) {
                MobilSortFilterAreaOpenOrClose(".mobilFilterArea", "Close"); // Filtreleme işlemi başarılıysa filtre alanını kapatıyoruz
                MobilSortFilterAreaOpenOrClose(".MobilSortArea", "Close"); // Filtreleme işlemi başarılıysa sıralama alanını kapatıyoruz
                var cookieGrid = $.cookie("TTgridCookie");
                MobileGridSet(cookieGrid);
            }
            else {
                GetSelectedFilter();// Seçimleriniz Alanına Seçili Filtreleri Ekler
            }

            SetUrl();

        },
        error: function () {
            ShowOrHideBackDrop("hide"); // Loader kapatılır
        }
    });
}

function SetUrl() {
    var sr = $("#PID").val();
    var CurrentPageTitle = $("#PageTitle").val();
    var CurrentH1Title = $("#PageH1").val();
    var CustomFiltersTitle = "";
    var CustomFilterURL = "";
    var i = 0;

    $("#Properties li.selected").each(function (index) { // Seçili özellikleri döndürür
        if (i == 0) {
            CustomFiltersTitle += $(this).find(".checkText").text();
            CustomFilterURL += $(this).find("input").attr("data-url");
        }
        else {
            CustomFiltersTitle += ", " + $(this).find(".checkText").text();
            CustomFilterURL += "-" + $(this).find("input").attr("data-url");
        }
        i++;
    });

    $("#Cloth li.selected").each(function (index) { // Seçili bedenleri döndürür
        if (i == 0) {
            CustomFiltersTitle += $(this).find(".checkText").text();
            CustomFilterURL += $(this).find("input").attr("data-url");
        }
        else {
            CustomFiltersTitle += ", " + $(this).find(".checkText").text();
            CustomFilterURL += "-" + $(this).find("input").attr("data-url");
        }
        i++;
    });

    if (sr != null && sr != undefined && sr != "") {
        $("h1").html(sr + " " + CustomFiltersTitle + " " + CurrentH1Title);
    }
    else {
        $("h1").html(CustomFiltersTitle + " " + CurrentH1Title);
    }


    CustomFiltersTitle = CustomFiltersTitle + " " + CurrentPageTitle;
    $(document).prop('title', CustomFiltersTitle);

    var Hash = window.location.href.slice(window.location.href.indexOf('?') + 1);
    var CurrentPath = $("#ParentCatalogURL").val();
    var SmallLangCode = $("#SmallLangCode").val();

    if (CustomFilterURL != "") {
        CustomFilterURL += "--";
    }

    if (CurrentPath == "" || CurrentPath == null || CurrentPath == undefined) {
        CurrentPath = "p/NewCat/NewSearch";
    }

    window.history.pushState('', '', "/" + SmallLangCode + "/" + CurrentPath.replace("{ReplacePlace}", CustomFilterURL) + "?" + Hash);
}

// Filtreleme Ve Sayfalama İsteklerinde Parametre Oluşturur
function GenerateParams($action, $pageNo) {
    var params = "";

    if ($action != null && $action != "" && $action != undefined) {

        // Sayfa Numarasını Ayarlar
        if ($action == "paging") {
            params = "p=" + $pageNo;
        }
        else if ($action == "filter") {
            params = "p=1";
        }
        // Sayfa Numarasını Ayarlar

        if (!IsSearch()) {
            params += "&ct=" + $("#PID").val(); // Catalog ID'sini alır
        }
        else {
            params += "&sr=" + $("#PID").val(); // Search değerini alır
        }

        // Cookide kayıtlı grid değeri varsa onu ekler
        cookieGrid = $.cookie("TTgridCookie");
        if (cookieGrid != null && cookieGrid != "" && cookieGrid != undefined) {
            params += "&g=" + cookieGrid;
        }
        // Cookide kayıtlı grid değeri varsa onu ekler

        // Tükenenleri Gizle Seçeneğini Kontrol Eder
        var SoldOut = $("#SoldOutOp li input").val();
        if (SoldOut == "1") {
            params += "&so=" + SoldOut;
        }
        // Tükenenleri Gizle Seçeneğini Kontrol Eder

        // Sıralama Seçeneğini Kontrol Eder
        $PrcSort = $("#PrdSort > li > label.checked");
        var SelectedSortID = $PrcSort.parent().children("input").val();
        if (SelectedSortID != null && SelectedSortID != "" && SelectedSortID != undefined) {
            params += "&o=" + SelectedSortID;
        }
        // Sıralama Seçeneğini Kontrol Eder

        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedColors = "";
        $("#Colors li.selected").each(function (index) { // Seçili renkleri döndürür
            SelectedColors += $(this).children("input").val() + ",";
        });

        if (SelectedColors != "" && SelectedColors != null && SelectedColors != undefined) {
            params += "&c=" + SelectedColors.substring(0, SelectedColors.length - 1); // Substring ile sondaki virgül silinir
        }
        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedSizes = "";
        $("#Sizes li.selected").each(function (index) { // Seçili bedenleri döndürür
            SelectedSizes += $(this).children("input").val() + ",";
        });

        if (SelectedSizes != "" && SelectedSizes != null && SelectedSizes != undefined) {
            params += "&s=" + SelectedSizes.substring(0, SelectedSizes.length - 1); // Substring ile sondaki virgül silinir
        }
        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedProperties = "";
        $("#Properties li.selected").each(function (index) { // Seçili özellikleri döndürür
            SelectedProperties += $(this).children("input").val() + ",";
        });

        if (SelectedProperties != "" && SelectedProperties != null && SelectedProperties != undefined) {
            params += "&prp=" + SelectedProperties.substring(0, SelectedProperties.length - 1); // Substring ile sondaki virgül silinir
        }
        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Kumaş Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedCloth = "";
        $("#Cloth li.selected").each(function (index) { // Seçili bedenleri döndürür
            SelectedCloth += $(this).children("input").val() + ",";
        });

        if (SelectedCloth != "" && SelectedCloth != null && SelectedCloth != undefined) {
            params += "&clh=" + SelectedCloth.substring(0, SelectedCloth.length - 1); // Substring ile sondaki virgül silinir
        }
        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Price Filtresini kontrol Eder, Varsa Params Değerine Ekler
        if ($("#SliderValue").val() != null && $("#SliderValue").val() != "" && $("#SliderValue").val() != undefined && $("#SliderValue").val() != "0-500") {
            params += "&prc=" + $("#SliderValue").val();
        }
        // Price Filtresini kontrol Eder, Varsa Params Değerine Ekler

    }

    return params;
}

// Sayfalama İşleminden Önce URL History Oluşturur
function GenerateUrlHistoy() {

    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // Var olan QueryString'i okur
    var PathName = window.location.pathname; // Bulunan kataloğun url'ini alır
    var CurrentURL = "";

    if (getQueryFilter.indexOf("=") != "-1") {
        CurrentURL = PathName + "?" + getQueryFilter;
    }
    else {
        CurrentURL = PathName;
    }

    if (CurrentURL != null && CurrentURL != "" && CurrentURL != undefined) {
        window.history.pushState('', '', CurrentURL);
    }
}

// Sayfalar Arası Gezerken Browser Back/Prev Butonlarını Kontrol Eder
function BrowserBackAndPrevButtonControl() {
    $(window).on('popstate', function (event) {

        var vars = [], hash;
        var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        var IsCatalogFirsPage = true;

        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "p") {
                getPageByPageNo(hash[1], "true");
                IsCatalogFirsPage = false;
            }
        }

        if (IsCatalogFirsPage == true) {
            getPageByPageNo(1, "true");
        }

    });
}

// Seçili Filtreleri Ekler
function GetSelectedFilter() {

    $SelectedFilterBody = $(".SelectedFilter .SelectedFilterBody ul");
    $SelectedFilterBody.html("");

    var Color = "Renk";
    var Size = "Beden";
    var Price = "Fiyat";
    var Propertie = "Özellik";
    var Cloth = "Kumaş";

    if ($("#SmallLangCode").val() == "en") {
        Color = "Color";
        Size = "Size";
        Price = "Price";
        Propertie = "Propertie";
        Cloth = "Cloth";
    }
    else if ($("#SmallLangCode").val() == "fr") {
        Color = "Couleur";
        Size = "Taille";
        Price = "Prix";
        Propertie = "Propertie";
        Cloth = "Cloth";
    }


    // Color Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Colors li.selected").each(function (index) { // Seçili renkleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='color'><img src='/Images/TTE/del.png' /></span>";
        $li += "<span class='SelectedFilterTitle'>" + Color + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Color Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Size Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Sizes li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='size'><img src='/Images/TTE/del.png' /></span>";
        $li += "<span class='SelectedFilterTitle'>" + Size + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Size Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Özellik Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Properties li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='properties'><img src='/Images/ALV/del.png' /></span>";
        $li += "<span class='SelectedFilterTitle'>" + Propertie + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Özellik Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Kumaş Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Cloth li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='cloth'><img src='/Images/ALV/del.png' /></span>";
        $li += "<span class='SelectedFilterTitle'>" + Cloth + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Kumaş Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Price Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $PriceSlide = $("#SliderValue").val();
    if ($PriceSlide != "0-500" && $PriceSlide != null && $PriceSlide != "" && $PriceSlide != undefined) {
        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $PriceSlide + "' data-type='price'><img src='/Images/TTE/del.png' /></span>";
        $li += "<span class='SelectedFilterTitle'>" + Price + ":</span> " + $PriceSlide;
        $li += "</li>";

        $SelectedFilterBody.append($li);
    }
    // Price Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler 

    if ($SelectedFilterBody.find("li").length > 0) {
        OpenCloseSelectedFilterArea("Up"); // Filtre seçiliyse Seçili Filtreler alanını açar

        // Tüm filtreleri temizleme seçeneği
        var ClearText = "Seçimleri Temizle";
        if ($("#SmallLangCode") == "en") {
            ClearText = "Clear Selections";
        }
        else if ($("#SmallLangCode") == "fr") {
            ClearText = "Effacer Les Sélections";
        }

        $li = "<li><span class='ClearAllFilter'>" + ClearText + "</span></li>";
        $SelectedFilterBody.append($li);
        // Tüm filtreleri temizleme seçeneği
    }
    else {
        OpenCloseSelectedFilterArea("Down"); // Filtre seçili değilse Seçili Filtreler alanını kapatır
    }
}

// Seçili Filtreleri Kaldıran Fonksiyon
function ClearSelectedFilter($selectedVal, $selectedType) {
    var selectedVal = $selectedVal;
    var selectedType = $selectedType;

    if (selectedVal != null && selectedVal != "" && selectedVal != undefined && selectedType != null && selectedType != "" && selectedType != undefined) {
        if (selectedType == "color") { // Filtre alanındaki seçili Color fitresini kaldırır
            $("#Colors li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Colors li label[for='c-" + selectedVal + "']").removeClass("c_on");
            $("#Colors li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "size") { // Filtre alanındaki seçili Size fitresini kaldırır
            $("#Sizes li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Sizes li label[for='s-" + selectedVal + "']").removeClass("c_on");
            $("#Sizes li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "properties") { // Filtre alanındaki seçili Özellik fitresini kaldırır
            $("#Properties li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Properties li label[for='s-" + selectedVal + "']").removeClass("c_on");
            $("#Properties li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "properties") { // Filtre alanındaki seçili Kumaş fitresini kaldırır
            $("#Cloth li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Cloth li label[for='s-" + selectedVal + "']").removeClass("c_on");
            $("#Cloth li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "price") { // Filtre alanındaki seçili Price fitresini kaldırır
            $("#MinPrice").val("0");
            $("#MaxPrice").val("500");
            $("#SliderValue").val("0-500");
            var slider = document.getElementById('PriceSlider');
            slider.noUiSlider.reset();
            GetPageByFilter();
        }
    }
}

// Tüm Filtreleri Kaldıran Fonksiyon
function ClearAllFilter($IsReload) {

    // Color filtrelerini kaldırır
    $("#Colors li input").removeAttr("checked");
    $("#Colors li label").removeClass("c_on");
    $("#Colors li input").parent("li").removeClass("selected");

    // Size filtrelerini kaldırır
    $("#Sizes li input").removeAttr("checked");
    $("#Sizes li label").removeClass("c_on");
    $("#Sizes li input").parent("li").removeClass("selected");

    // Özellik filtrelerini kaldırır
    $("#Properties li input").removeAttr("checked");
    $("#Properties li label").removeClass("c_on");
    $("#Properties li input").parent("li").removeClass("selected");

    // Kumaş filtrelerini kaldırır
    $("#Cloth li input").removeAttr("checked");
    $("#Cloth li label").removeClass("c_on");
    $("#Cloth li input").parent("li").removeClass("selected");

    // Price filtresini kaldırır
    $("#MinPrice").val("0");
    $("#MaxPrice").val("500");
    $("#SliderValue").val("0-500");
    var slider = document.getElementById('PriceSlider');
    slider.noUiSlider.reset();

    if ($IsReload == "true") {
        GetPageByFilter(); // Filtreleri temizledikten sonra istek yapar
    }
}

// Mobil Filtre ve Sıralama Alanını Aldığı Değere Göre Açıp/Kapatan Fonksiyon
function MobilSortFilterAreaOpenOrClose($AreaName, $event) {
    if ($AreaName != null && $AreaName != "" && $AreaName != undefined && $event != null && $event != "" && $event != undefined) {
        if ($event == "Open") {
            $($AreaName).css("height", "100%").slideDown("slow");
            $('html, body').css("height", "100%").css("overflow", "hidden");
        }
        else if ($event == "Close") {
            $($AreaName).css("height", "100%").slideUp("slow");
            $('html, body').css("height", "auto").css("overflow", "unset");
        }
    }
}